export enum LocationSearchScopeEnum {
    IncludeAnyAndRemote = 1,
    ExcludeAnyAndRemote = 2,
    ExcludeAny = 4,
}
